var React = require('react');

function ArrowUpWithBody (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.564866 6.65685L6.92883 0.292892C7.31935 -0.0976315 7.95252 -0.0976315 8.34304 0.292892L14.707 6.65685C15.0975 7.04738 15.0975 7.68054 14.707 8.07107C14.3165 8.46159 13.6833 8.46159 13.2928 8.07107L8.63593 3.41421L8.63593 25C8.63593 25.5523 8.18822 26 7.63593 26C7.08365 26 6.63593 25.5523 6.63593 25L6.63593 3.41421L1.97908 8.07107C1.58856 8.46159 0.95539 8.46159 0.564866 8.07107C0.174342 7.68054 0.174342 7.04738 0.564866 6.65685Z","fill":"#001D3B"}));
}

ArrowUpWithBody.defaultProps = {"width":"15","height":"26","viewBox":"0 0 15 26","fill":"none"};

module.exports = ArrowUpWithBody;

ArrowUpWithBody.default = ArrowUpWithBody;
